import { useLocation } from 'react-router';
import { useTenant } from '../contexts/TenantContext';

/** Top-level routes that are not a workspace slug. */
const NON_TENANT_ROUTES = new Set(['tenants', 'personas', 'canned-responses', 'contacts', 'no-access']);

/**
 * The workspace in the URL (/:tenantSlug/...), if any. For components outside the routes (the header):
 * `selectedTenantId` is not set on the inbox route, and `useParams` does not see the slug from there.
 */
export function useUrlTenant() {
  const { tenants } = useTenant();
  const location = useLocation();
  const firstSegment = location.pathname.split('/').filter(Boolean)[0];
  return firstSegment && !NON_TENANT_ROUTES.has(firstSegment)
    ? tenants.find((t) => t.slug === firstSegment)
    : undefined;
}
